import { render, staticRenderFns } from "./room_items.vue?vue&type=template&id=4245c98c&scoped=true"
import script from "./room_items.vue?vue&type=script&lang=js"
export * from "./room_items.vue?vue&type=script&lang=js"
import style0 from "./room_items.vue?vue&type=style&index=0&id=4245c98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4245c98c",
  null
  
)

export default component.exports